import { computed } from 'vue';
import { useSelectedIds } from '@/lib/hooks';
import { useQuery } from '@tanstack/vue-query';

import { fetchUsersSimplified } from '@/api/user';

import { USERS_SIMPLIFIED_API } from '@/constants/api';
import { PATENTS_PLATFORM_FILTERING } from '@/constants/filtering';

import type { UserSimplified } from '@/types/users';

function useUsersSimplified(
  useParams = false,
  usePatentsPlatformFiltering = true
) {
  const selectedIds = useSelectedIds(useParams);

  const { data, isError, isFetching } = useQuery({
    queryKey: [USERS_SIMPLIFIED_API, selectedIds],
    queryFn: () =>
      fetchUsersSimplified({
        user_ids: selectedIds.value,
        ...(usePatentsPlatformFiltering && {
          additionalFilters: PATENTS_PLATFORM_FILTERING
        })
      }),
    select(data) {
      return data.data;
    }
  });

  const simplifiedUsers = computed<UserSimplified[]>(() => {
    return data.value ?? [];
  });

  return { simplifiedUsers, isError, isFetching };
}

export default useUsersSimplified;
